export const DRAFT_GET_ALL = "/draft";
